import { FieldErrors } from 'react-hook-form';

// Utility function to get field error message
export function getFieldError(errors: any, fieldName: string): string | undefined {
  return errors[fieldName]?.message;
}

// Utility function to check if field has error
export function hasFieldError(errors: any, fieldName: string): boolean {
  return !!errors[fieldName];
}

// Utility function to get field helper text
export function getFieldHelperText(
  errors: any,
  fieldName: string,
  defaultHelperText?: string
): string | undefined {
  const error = getFieldError(errors, fieldName);
  return error || defaultHelperText;
}